const topics = [
  { tag: '长安如故', posts: '128万', desc: '古装权谋巅峰之作' },
  { tag: '暑期追剧', posts: '96万', desc: '暑假必看片单推荐' },
  { tag: '深渊之光', posts: '85万', desc: '悬疑烧脑反转不断' },
  { tag: '古装剧推荐', posts: '72万', desc: '服化道在线口碑好剧' },
  { tag: '韩剧热播', posts: '68万', desc: '最新韩剧资源大全' },
  { tag: '星辰大海', posts: '61万', desc: '都市情感治愈力作' },
  { tag: '高分国产剧', posts: '55万', desc: '豆瓣8分以上必看' },
  { tag: '九州风云录', posts: '49万', desc: '特效炸裂玄幻巨制' },
  { tag: '追剧打卡', posts: '43万', desc: '每日追剧讨论分享' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            追剧达人们都在讨论什么？加入话题，分享你的观剧心得
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((item, index) => (
            <div
              key={index}
              className="group flex flex-col p-4 md:p-5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/20 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs md:text-sm text-accent-500">
                  <i className="ri-hashtag"></i>
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.tag}
                </h3>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 mb-3 line-clamp-1">
                {item.desc}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500 mt-auto">
                <i className="ri-chat-3-line"></i>
                <span>{item.posts}讨论</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}